// extracted by mini-css-extract-plugin
export var alt = "GlobalAlert-module--alt--62149";
export var container = "GlobalAlert-module--container--c310a";
export var desktopOnly = "GlobalAlert-module--desktopOnly--cbbfe";
export var main = "GlobalAlert-module--main--fcbb3";
export var mobileOnly = "GlobalAlert-module--mobileOnly--a7d4e";
export var styledWrapper = "GlobalAlert-module--styledWrapper--da270";
export var textLeft = "GlobalAlert-module--textLeft--1bfc4";
export var visuallyHidden = "GlobalAlert-module--visuallyHidden--9ad00";